import { useEffect, useState } from "react";
import Table from "../../../components/table";

const NotificationHistory = ({ alerts }) => {
  const [pushNotifications, setPushNotifications] = useState([]);
  const [page, setPage] = useState(0);
  const alertsPerPage = 8;

  useEffect(() => {
    const tableRows = alerts?.map((notif) => ({
      id: notif?.id,
      title: notif?.title,
      description: notif?.text,
      scheduledDate: convertUTCToLocal(notif?.datetime),
      status: notif?.status,
    }));
    setPushNotifications(tableRows);
  }, [alerts]);

  function convertUTCToLocal(utcDateString) {
    const utcDate = new Date(utcDateString + "Z"); // Add 'Z' to indicate it's UTC
    return utcDate?.toLocaleString(); // Converts to local time
  }

  const totalPages = Math.ceil(alerts.length / alertsPerPage);
  const displayedAlerts = pushNotifications?.slice(
    page * alertsPerPage,
    (page + 1) * alertsPerPage
  );

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 0 && pageNumber < totalPages) {
      setPage(pageNumber);
    }
  };

  const headings = [
    {
      name: "Title",
      fieldName: "title",
      isSortable: false,
      sortKey: "none",
    },
    {
      name: "Description",
      fieldName: "description",
      isSortable: false,
      sortKey: "none",
    },
    {
      name: "Scheduled Date",
      fieldName: "datetime",
      isSortable: false,
      sortKey: "none",
    },
    {
      name: "Status",
      fieldName: "status",
      isSortable: false,
      sortKey: "none",
    },
  ];

  return (
    <Table
      headings={headings}
      data={displayedAlerts}
      currentPage={page}
      totalPages={totalPages}
      onPageChange={handlePageChange}
      enablePagination={alerts.length > alertsPerPage}
      card={true}
    />
  );
};

export default NotificationHistory;
